import { useMutation } from '@apollo/client/react';
import { gql } from '@apollo/client';
import { SignInPayload } from '../generated/types';

const SIGN_IN_MUTATION = gql`
  mutation SignIn($email: String!, $password: String!) {
    signIn(email: $email, password: $password) {
      user {
        id
        email
        fullName
        role
      }
    }
  }
`;

export function useSignIn() {
  const [signInMutation, { loading, error }] = useMutation<{ signIn: SignInPayload }>(SIGN_IN_MUTATION);

  const signIn = async (email: string, password: string) => {
    const { data } = await signInMutation({
      variables: { email, password },
    });
    return data?.signIn?.user;
  };

  return { signIn, loading, error };
}
